import { render, staticRenderFns } from "./MarketMap.vue?vue&type=template&id=3996149c&scoped=true"
import script from "./MarketMap.vue?vue&type=script&lang=js"
export * from "./MarketMap.vue?vue&type=script&lang=js"
import style0 from "./MarketMap.vue?vue&type=style&index=0&id=3996149c&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996149c",
  null
  
)

export default component.exports